var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-preview',{attrs:{"url":_vm.url},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.title))])]}}])},[_c('template',{slot:"loading"},[_c('div')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }